import keyMirror from 'keymirror';

const MODE = keyMirror({
  debug: null,
  essay: null,
  exam: null,
  review: null,
  share: null,
});

export default MODE;
